import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, delay, map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class ReasonService {

  // _liveApiUrl: any = this.authService._liveApiUrl;
     get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  private _reason = new BehaviorSubject<object[]>([]);
  private reasonData: { reason: object[] } = { reason: [] };
  private _reason1 = new BehaviorSubject<object[]>([]);
  private reasonData1: { reason1: object[] } = { reason1: [] };
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService
  ) {}
  getReason(): Observable<any> {
    return this.http .get<any>(`${this._liveApiUrl}/company/status-reason/`)
  }
  countCancelunsuccessful():Observable<any> {
    return this.http .get<any>(`${this._liveApiUrl}/company/reason-count/`)
  }
  reasonDelete(id: any) {
    return this.http.delete<any>(
      `${this._liveApiUrl}/company/status-reason-delete/${id}`
    );
  }
  getReasonUnSuccessfull(page?: number){
    return this.http .get<any>(`${this._liveApiUrl}/company/status-reason/?status=unsuccessful&page=${page}`)
  }
  getReasonCanceled(page?: number){
    return this.http .get<any>(`${this._liveApiUrl}/company/status-reason/?status=cancelled&page=${page}`)
  }
  getAdminControll(){
    return this.http .get<any>(`${this._liveApiUrl}/notification/get-admins-settings-permissions/`)
  }
  
  reasonSearchcancelled(page?: number, searchVal?: string, status: string = 'cancelled') {
    let tail = '';
  
    // Construct the query string for searchVal and page
    if (searchVal) {
      tail += `search_text=${searchVal}&`;
    }
  
    // Add page to the query string if provided
    if (page) {
      tail += `page=${page}&`;
    }
  
    // Add status to the query string
    tail += `status=${status}`;
  
    this.http
      .get<any>(`${this._liveApiUrl}/company/status-reason/?${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {
  
          this.reasonData.reason = data;
          this._reason.next(Object.assign({}, this.reasonData).reason);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  reasonSearchunsuccessful(page: number, searchVal?: string, status: string = 'unsuccessful') {
    let tail = '';
  
    // Construct the query string for searchVal and page
    if (searchVal) {
      tail += `search_text=${searchVal}&`;
    }
  
    // Add page to the query string if provided
    if (page) {
      tail += `page=${page}&`;
    }
  
    // Add status to the query string
    tail += `status=${status}`;
  
    this.http
      .get<any>(`${this._liveApiUrl}/company/status-reason/?${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {
  
          this.reasonData1.reason1 = data;
          this._reason1.next(Object.assign({}, this.reasonData1).reason1);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  getreasonscancelled(): Observable<any[]> {
    return this._reason.asObservable();
  }
  getreasonsunsuccessful(): Observable<any[]> {
    return this._reason1.asObservable();
  }
  addReason(form: any){
    return this.http
    .post<any>(`${this._liveApiUrl}/company/status-reason-create/`, form)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.authService.handleError)
    );
  }
  reasonDetails(id?: Number) {
    let tail = '';
    if (id) {
      tail = `${id}`;
    }

    this.http
      .get<any>(`${this._liveApiUrl}/company/get-status-reason/${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      ).subscribe(
        (data: any) => {


          this.reasonData.reason = data;

          this._reason.next(Object.assign({}, this.reasonData).reason);

        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  getReasons(): Observable<any[]> {
    return this._reason.asObservable();
  }
  reasonEdit(id: Number, form: any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/company/status-reason-update/${id}`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }
}
